import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action"
};

const initialAuthState = {
  user: undefined
};

export const reducer = persistReducer(
    { storage, key: "demo1-auth", whitelist: ["user", "authToken"] },
    (state = initialAuthState, action) => {
      switch (action.type) {
        case actionTypes.Login: {

          const { user } = action.payload;

          return { ...state, user };
        }

        case actionTypes.Logout: {
          routerHelpers.forgotLastLocation();
          return initialAuthState;
        }


        default:
          return state;
      }
    }
);

export const actions = {
  login: (user) => ({ type: actionTypes.Login, payload: {user} }),
  logout: () => ({ type: actionTypes.Logout })
};


